import { useFeatureFlagValue } from "@mirage/service-experimentation/useFeatureFlagValue";
import { useMemo } from "react";

type FilterSidebarView = {
  contentType: boolean;
  app: boolean;
};

// following useMultimediaview pattern because the current app sidebar implementation will
// double the number of search requests and the flag is already ON for all Dash
export const useFilterSidebarView = (): FilterSidebarView => {
  const filterSidebarValue = useFeatureFlagValue(
    "dash_2025_05_29_serp_filter_sidebar",
  );
  const filterSidebarView = useMemo(() => {
    if (filterSidebarValue === "ON") {
      return { contentType: true, app: false };
    } else if (filterSidebarValue === "V1") {
      return { contentType: true, app: true };
    } else {
      return { contentType: false, app: false };
    }
  }, [filterSidebarValue]);
  return filterSidebarView;
};
